// extracted by mini-css-extract-plugin
export default {"wrapper":"record-audio-button-module__wrapper--PhyEu","whiteBackground":"record-audio-button-module__whiteBackground--SGYb6","button":"record-audio-button-module__button--Ybxs1"};